import { faImages } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import React, { useCallback, useState } from "react";
import MediaSelectionModal, { MediaItem } from "../../../../../features/mediaLibrary/MediaSelectionModal";
import { dispatchInsertImageCommand } from "../../InlineImagePlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useIntl } from "react-intl";

export function Media()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const addImageFromMediaLibrary = useCallback((files: MediaItem[]) =>
    {
        for (const file of files)
        {
            dispatchInsertImageCommand(editor, file.path.replace('5000', '64829')); // TODO
            setIsModalOpen(false);
        }
    },
    [editor]);
    const element =
    <>
        <ToolbarButton title={translations?.insertImage ?? 'Insert image'} icon={faImages} onClick={() => setIsModalOpen(true)} />
        <MediaSelectionModal defaultItemsChecked={[]} isOpen={isModalOpen} setIsOpen={setIsModalOpen} onSubmit={addImageFromMediaLibrary} />
    </>;
    return element;
}